<template lang="pug">
<div class="container bg1" :class="classmainmenu">
	<notifications group="success" position="top center" width="80%"/>
	<notifications group="warn" position="top center" width="80%"/>
	<SpaNav />
	<div class="w3-container w3-padding-32 bgimg2 containerpaddingtop marginbottom200 paddingtop100">
		<router-view />
	</div>
	<Loader v-if="loading != 0" />
	<Foot />
</div>
</template>

<script>
    export default {
        computed: {
            loading() {
                return this.$store.state.services.loading;
            },
			classmainmenu() {
				return this.$store.state.options.class_mainmenu;
			},
        },
        mounted() {
            console.log('App mounted.');
        },
		methods: {
			
		}
		
    }
</script>
<style>

</style>